type Props = {
  children?: React.ReactNode;
};

function ActionBar({ children }: Props) {
  return <div className="actionbar-wrapper">{children}</div>;
}

export default ActionBar;
